import type { FC } from 'react';
import { Button } from '@mui/material';
import { ExpandMoreOutlined } from '@mui/icons-material';
import i18n from '@shared/config/i18n';
import type { Props } from './types';

export const ResponsiveButtons: FC<Props> = ({
  buttons,
  currentWidth,
  collapseWidth,
  menu,
  onMenuOpen,
}) => {
  if (currentWidth > collapseWidth) {
    return <>{buttons}</>;
  }

  return (
    <>
      <Button
        color="primary"
        variant="outlined"
        endIcon={<ExpandMoreOutlined />}
        onClick={onMenuOpen}
      >
        {i18n.t('Label.actions')}
      </Button>
      {menu}
    </>
  );
};
